<template>
  <!-- TODO: vue-split-layout, https://github.com/vue-hxs/vue-split-layout -->
  <div class="app">
    <!-- :edit="state.edit" -->
    <Layout
      :resize="state.resize"
      :splits="state.splits">
      <!-- <div class="nopane">
      </div> -->
      <div class="custom-drag">
        <div class="container">
          testing a drag handle 0
        </div>
      </div>
      <div class="custom-drag">
        <div class="container">
          testing a drag handle 1
        </div>
      </div>
      <div class="custom-drag">
        <div class="container">
          testing a drag handle 2
        </div>
      </div>
      <!-- <Pane title="Drag me too">Stuff</Pane> -->
      <Pane title="Third">Testing dynamic split</Pane>
      <div class="custom-drag">
        <div class="container">
          testing a drag handle
          <!-- <div
            class="drag-handle"
            pane-drag>DRAG HERE</div> -->
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import { Layout, Pane } from 'vue-split-layout'

// Sample layouts
// split:'20%' means first pane will be 20% second the rest
// note that:
//   vertical first node is top, second is bottom
//   horizontal first node is left, second is right
// And still need to figure out a better way to define the splits
const layouts = [
  {
    dir: 'horizontal',
    first: {
      dir: 'vertical',
      first: 0,
      second: 2,
      split: '100%'
    },
    second: {
      dir: 'horizontal',
      first: 4,
      second: 1
    },
    split: '20%'
  }
  // Second layout
  // {
  //   dir: 'horizontal',
  //   first: {
  //     dir: 'vertical',
  //     first: { dir: 'horizontal', first: 0, second: 3, split: '20%' },
  //     second: 2
  //   },
  //   second: 1
  // }
]

export default {
  name: 'App',
  components: { Layout, Pane },
  data () {
    return {
      state: {
        extraStyle: false,
        edit: true,
        resize: true,
        splits: layouts[0],
        layoutN: 0
      },
      hi: 'world'
    }
  },
  methods: {
  }
}
</script>

<style type="scss">
* {
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
}

::-moz-focus-inner {
  border: 0;
}

:focus {
  outline: none;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  height: 100vh;
  background: #ddd;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* #root {
  height: 100%;
} */

.app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* .app .nopane * {
  background: rgba(250, 250, 150, 0.5);
} */

.layout-container > .drag.dragging {
  z-index: 20;
  cursor: move;
}

.split.resizeable > .splitter::after {
  position: absolute;
  content: " ";
  z-index: 10;
  transition: all 0.3s;
  top: -8px;
  right: -8px;
  bottom: -8px;
  left: -8px;
}

.split>.content {
  overflow: scroll !important;
}

/* Custom Styling */
.layout-container>* {
  margin: 0px !important;
  box-sizing: border-box;
}
.extra .layout-container,
.split {
  background: #ddd;
}

.extra .layout-container > .views {
  margin: 0px;
}

.extra .layout-container .view {
  border: solid 1px transparent;
  transition: all 0.3s;
}

.extra .layout-container.edit .view {
  border: dotted 1px rgba(100, 100, 100, 0.4);
}

.extra .layout-container > .preview {
  background: rgba(0, 0, 0, 0.2);
  border: dashed 1px #666;
  transition: all 0.3s;
  padding: 0;
  margin: 0;
}

.extra .layout-container > .drag {
  display: block;
  opacity: 0;
  transform: scale(1);
}

.extra .layout-container > .drag.dragging {
  opacity: 0.7;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.4);
  transform: scale(0.5);
  transition: transform 0.3s;
}

.extra .layout-container > .drag * {
  pointer-events: none !important;
}

.extra .split > .splitter {
  flex-basis: 6px;
  position: relative;
  background: transparent;
  transition: all 0.3s;
}

.extra .split.resizeable > .splitter {
  background: rgba(100, 100, 100, 0.2);
}

.extra .split.resizeable > .splitter::after {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.extra .split.resizeable.horizontal > .splitter::after {
  right: -6px;
  left: -6px;
}

.extra .split.resizeable.vertical > .splitter::after {
  top: -6px;
  bottom: -6px;
}

.extra .split.resizeable.resizing > .splitter::after,
.extra .split.resizeable > .splitter:hover::after {
  background: rgba(155, 155, 155, 0.5);
}

.extra .pane {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.extra .pane > .header {
  text-transform: uppercase;
  background: #eee;
  color: #444;
}

.extra .pane > .content {
  background: #fefefe;
  padding: 10px;
}

/* new drag area */
.custom-drag {
  height: 100%;
  background: #eee;
}

.split>.splitter {
  flex-basis: 6px;
  background: #ddd !important;
}

/* .drag-handle {
  background: #fff;
  padding: 20px;
  border: solid 1px #f99;
} */
</style>
